import React from 'react';

const Checkbox = ({id_input, label, onClick, checked}) => {
    const defaultStyle = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px"
    };

    return (
        <div style={{...defaultStyle}}>
            <label className="inline-flex relative items-center cursor-pointer">
                <input type="checkbox" value=""
                       id={id_input}
                       className="sr-only peer"
                       role="switch"
                       onClick={onClick}
                       onTouchEnd={onClick}
                       checked={checked}
                />
                <div className="w-14 h-7 bg-seizo-rouge peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-gray-300 rounded-full
                peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5
                after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6
                after:transition-all peer-checked:bg-seizo-vert"></div>
            </label>
            <label
                htmlFor={id_input}
                className="ml-0 mr-3 nameQuart_validation"
            >
                {label}
            </label>
        </div>
    );
};

export default Checkbox;
